import FlatButton from "@/components/button/button";
import { BASE_URL } from "@/env";
import { Flex, Typography } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import { Cookies } from "react-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";

const authorization = async (accessToken: string, type: String) => {
    try {
        const formData = {
            "access_token": accessToken,
        };
        const res = await fetch(`${BASE_URL}/authen`,
            {
                method: "POST",
                body: JSON.stringify(formData),
            }
        )
        const data = await res.json();
        return data;
    } catch (error) {
        throw error;
    }
};

const AuthenticationScreen: React.FC = () => {
    const navigate = useNavigate();

    const cookies = useMemo(() => new Cookies(null, { path: '/' }), [])

    const clearSession = useCallback(async () => {
        const type = await localStorage.getItem("login-type");
        await cookies.remove(type + "-jwt")
        await localStorage.removeItem(type + "-jwt")
        await localStorage.removeItem("login-type")
        navigate('/', { replace: true });
    }, [navigate, cookies]);

    const handleAuthorization = useCallback(async (callback: () => void) => {
        const type = await localStorage.getItem("login-type");
        try {
            const token = await localStorage.getItem("token")
            const userInfo: any = await authorization(token ?? "", type ?? "");

            if (userInfo.code != 200) {
                clearSession();
            } else {
                callback();
            }

        } catch (error) {
            clearSession()
        }
    }, [cookies, clearSession]);

    useEffect(() => {
        handleAuthorization(() => { });
    }, []);


    const onNavigateToWebServerA = useCallback(async () => {
        handleAuthorization(() => {
            navigate("/web-server-a");
        });
    }, []);

    const onNavigateToWebServerB = useCallback(async () => {
        handleAuthorization(() => {
            navigate("/web-server-b");
        });
    }, []);

    return (
        <Flex gap="middle" align="center" vertical>
            <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
                AuthPOC（デモ）画面
            </Typography.Text>
            <FlatButton
                size="large"
                type="primary"
                style={{ width: 360 }}
                onClick={onNavigateToWebServerA}
            >
                WebServer-Aへ接続
            </FlatButton>
            <FlatButton
                size="large"
                type="primary"
                style={{ width: 360 }}
                onClick={onNavigateToWebServerB}
            >
                WebServer-Bへ接続
            </FlatButton>
            <FlatButton
                size="large"
                type="primary"
                style={{ width: 360 }}
                onClick={clearSession}
            >
                終了
            </FlatButton>
        </Flex>
    );
};

export default AuthenticationScreen;
